function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import data from './domains.js';

(function ($) {
  $(document).ready(function () {
    //IE check
    var ua = window.navigator.userAgent.toLowerCase(),
        is_ie = /trident/gi.test(ua) || /msie/gi.test(ua);

    if (is_ie) {
      $('body').addClass('IE');
    } //IE check
    //burger, open close header mobile


    if ($('.burger').length) {
      $('.burger').click(function () {
        $('.burger').toggleClass('clicked');
        $('body').toggleClass('nav-active');
      });
    } //burger, open close header mobile
    //sticky header scroll


    if ($(window).scrollTop() > 0) {
      $('body').addClass('scroll');
    } else {
      $('body').removeClass('scroll');
    }

    $(document).on('scroll', function () {
      if (!$('body').hasClass('scroll')) {
        $('body').addClass('scroll');
      }

      if ($(window).scrollTop() == 0) {
        $('body').removeClass('scroll');
      }

      if ($(window).scrollTop() > 500) {
        $('.up').addClass('active');
      } else {
        $('.up').removeClass('active');
      }
    }); //sticky header scroll
    //Function up for go to top

    $('.up').click(function () {
      $("html, body").animate({
        scrollTop: 0
      }, 600);
      return false;
    }); //Function up for go to top
    //Function scrollto

    $(".scrollto a:not(.add_session)").on('click', function (e) {
      e.preventDefault();
      var url = window.location.href.split('#')[0],
          thisUrl = $(this).attr('href').split('#')[0];

      if (url.substr(-1) == "/") {
        url = url.slice(1, -1);
      }

      if (thisUrl.substr(-1) == "/") {
        thisUrl = thisUrl.slice(1, -1);
      }

      if (url == thisUrl) {
        var target = $(this).attr('href').split('#')[1];
        var destination = $('#' + target).offset().top - 50;
        setTimeout(function () {
          // window.scrollTo({
          //     top: destination,
          //     behavior: 'smooth'
          // });
          $('html, body').animate({
            scrollTop: destination
          }, 1000);
        }, 1);
      } else {
        window.location.href = $(this).attr('href');
      }
    });
    var url = window.location.href;
    $('html, body').animate({
      scrollTop: $("body").offset().top
    }, 0);

    if (url.indexOf('#') != -1) {
      if (url.split('#')[1]) {
        var target = url.split('#')[1];
        var destination = $('#' + target).offset().top - 50;
        setTimeout(function () {
          window.scrollTo({
            top: destination,
            behavior: 'smooth'
          });
        }, 100);
      }
    } //Function scrollto
    //dropdown select start


    $('.js__dropdown').on('click', function (e) {
      $(this).toggleClass('active');
      $(this).find('.dropdown__dropdown').slideToggle();
      e.stopPropagation();
    }); //dropdown select end
    //----------forms style

    function formStyle() {
      //select2 start
      if ($("select").length) {
        setTimeout(function () {
          $("select").each(function (index, item) {
            $(item).closest('.gfield').find('.gfield_label').val();
            var text = $(item).closest('.gfield').find('.gfield_label').text();
            $(item).select2({
              placeholder: text,
              minimumResultsForSearch: -1
            });
          });
        }, 100);
      } //select2 end
      //gravity forms


      if ($(".ginput_container_checkbox").length) {
        $(".ginput_container_checkbox").closest('.gfield').addClass('checkboxField');
      }

      if ($(".gform_button").length) {
        $(".gform_button").addClass('btn btn_long');
      }

      if ($(".gfield_checkbox input[type='checkbox']").length) {
        $(".gfield_checkbox input[type='checkbox']").change(function () {
          if ($(this).prop("checked")) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
        });
      } //gravity forms

    } //validation email


    function emailVal() {
      if ($(".gform_wrapper .email_input").length) {
        $('.gfield.email_input').append('<p class="error-string">This is not a professional email</p>');
        $(".gform_wrapper .email_input input").change(function () {
          var string = $(this).val().split('@')[1];

          function appendString() {
            $('.gfield.email_input .error-string').addClass('active');
            $('.gfield.email_input').addClass('gfield_error');
            $('.gform_footer .gform_button').attr('disabled', 'disabled');
          }

          if ($(this).val().indexOf('@') == -1) {
            appendString();
          } else {
            var _iterator = _createForOfIteratorHelper(data),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var item = _step.value;

                if (item == string) {
                  appendString();
                  break;
                } else {
                  if ($('.gfield.email_input .error-string').length) {
                    $('.gfield.email_input .error-string').removeClass('active');
                    $('.gfield.email_input').removeClass('gfield_error');
                  }

                  $('.gform_footer .gform_button').removeAttr("disabled");
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            ;
          }
        });
      }
    } //validation email


    formStyle();
    emailVal();
    jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
      formStyle();
      emailVal();
    });
    jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
      if ($(".contact-form__wrapper .gform_confirmation_wrapper").length) {
        setTimeout(function () {
          $(".contact-form__wrapper").addClass('success-confirmation');
        }, 100);
      }

      if ($(".contact-form__wrapper .error").length) {
        setTimeout(function () {
          $(".contact-form__wrapper").addClass('error-confirmation');
        }, 100);
      }
    }); //----------forms style
  });
})(jQuery);